<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Coupon',
  components: {},
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.full-heigth {
  position: relative;
  height: 100%;
}
</style>
